export interface ServiceValidationTemplateModel {

  id?: string;
  name?: string;
  validationLevel?: ServiceValidationLevel;
  fieldValidation?: ServiceFieldValidation;
  mandatory?: boolean;
  createdAt: number;
  updatedAt: number;
  archive: boolean;
}


export enum ServiceValidationLevel {
  Task = "Task",
  Package = "Package",
  PackageGroup = "PackageGroup"
}

export enum ServiceFieldValidation {
  General = "General",
  TotalQuantity = "TotalQuantity",
  ProNumber = "ProNumber",
  ExternalId = "ExternalId",
  Barcode = "Barcode",
  PackageQuantity = "PackageQuantity"
}
